module.exports = __webpack_public_path__ + "media/images/mobile/mb-hamburger-cross0-6cae314937b1e4c5513c767c4744382b.png";